<template>
    <div class="loader">
        <div v-if="loading">
            <h3 class="loader__loading">
                {{loadingMessage || $t('loader.loading')}}
            </h3>
            <div class="spinner"></div>
        </div>
        <div v-else>
            <div v-if="error">
                <h3 class="loader__error">
                    {{errorMessage || $t('loader.error')}}
                </h3>
            </div>
            <div v-else>
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';

    @Component
    export default class Loading extends Vue {
        @Prop({default: false, type: Boolean})
        loading;
        @Prop({type: String})
        loadingMessage;
        @Prop({default: false, type: Boolean})
        error;
        @Prop({type: String})
        errorMessage;
    }
</script>



// WEBPACK FOOTER //
// src/components/general/Loader.vue